import React from 'react';
import clsx from 'clsx';

import { Header } from '.';
import { Logo } from '../../components';
import { useIsMobile } from '../../hooks';
import { useAppContext, useAuth, useLocalize } from '../../hooks';

export type MenuItem = {
  url?: string;
  text?: string;
  isPublic?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  component?: React.ComponentType<any>;
  action?: SpPermission;
};

type ResponsiveLayoutProps = {
  menuItems: MenuItem[];
  children: React.ReactNode;
};

const logosMap: { [x in LogoType]: React.ReactElement } = {
  default: <Logo src="/Logo.png" />,
  estate: <Logo src="/Estate.svg" />,
};

export const Layout: React.FC<ResponsiveLayoutProps> = ({
  menuItems,
  children,
}) => {
  const { t } = useLocalize();
  const isMobile = useIsMobile();
  const { logoType } = useAppContext();
  const { user, isEmbedded } = useAuth();
  const contentStyle = {
    height: isMobile
      ? 'calc(100dvh - 6.4rem)'
      : 'calc(100dvh - 7.2rem - 5.7rem)',
  };
  const contentClassName = 'mt-[6.4rem] mb-0 sm:mt-[7.2rem] sm:mb-[5.7rem]';
  const embeddedStyle = { height: '100dvh' };

  return (
    <div className="h-screen bg-white relative">
      {!isEmbedded && (
        <Header
          links={menuItems}
          isMobile={isMobile}
          userName={user?.name}
          avatarUrl={user?.picture}
          linkClassName="text-small"
          logo={logoType ? logosMap[logoType] || null : null}
          className="bg-activeHeader text-accordionBorder fixed left-0 right-0 top-0 z-header"
        />
      )}
      <div
        className={clsx('flex', !isEmbedded ? contentClassName : '')}
        style={!isEmbedded ? contentStyle : embeddedStyle}
      >
        {children}
      </div>
      {!isEmbedded && (
        <footer
          className={clsx(
            'hidden sm:flex',
            'flex-row items-center justify-between px-lg border-t-accordionBorder border-t',
            'overflow-y-auto h-[5.7rem] fixed left-0 right-0 bottom-0 bg-white'
          )}
        >
          <div>
            ⓒ {new Date().getFullYear()} {t('menu.footer.reserved')}.
          </div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={t('menu.footer.termslink')}
          >
            {t('menu.footer.terms')} - {t('menu.footer.policy')}
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={t('menu.footer.linked')}
          >
            LinkedIn
          </a>
        </footer>
      )}
    </div>
  );
};

export default Layout;
